@if (order; as orderConfirmationData) {
  <div class="confirmation-container" >
    <!-- SUCCESS BANNER -->
    <div class="success-banner">
      <h1 class="success-title">Order Confirmed!</h1>
      <p class="success-subtitle">Your order has been placed on account.</p>
      <!-- ORDER INFO GRID -->
      <div class="order-info-grid">
        <div class="order-info-item">
          <div class="order-info-label">Order Number</div>
          <div class="order-info-value large">{{orderConfirmationData?.code}}</div>
        </div>
        <div class="order-info-item">
          <div class="order-info-label">Order Date</div>
          <div class="order-info-value">{{ orderConfirmationData?.creationDate | date:'MMMM d, yyyy' }}</div>
        </div>
        <div class="order-info-item">
          <div class="order-info-label">PO Number</div>
          <div class="order-info-value">{{ orderConfirmationData?.purchaseOrderNumber ? orderConfirmationData?.purchaseOrderNumber : orderConfirmationData?.code }}</div>
        </div>
        <div class="order-info-item">
          <div class="order-info-label">Purchaser</div>
          <div class="order-info-value">{{orderConfirmationData?.deliveryContactInfo?.firstName}} {{orderConfirmationData?.deliveryContactInfo?.lastName}}</div>
        </div>
      </div>
    </div>
    <!-- ORDER DETAILS -->
    <div class="order-details">
      <!-- PRODUCTS SECTION WITH INTEGRATED SUMMARY -->
      <div class="detail-section">
        <h2 class="detail-section-title">
          Products Ordered
        </h2>
        @for (entry of orderConfirmationData?.orderEntries; track entry) {
          <div class="product-item">
            <div class="product-info">
              <span class="product-name">{{entry?.product?.name}}</span>
              <span class="product-quantity">- Qty: {{entry?.quantity}}</span>
            </div>
            <div class="product-price">{{ formatPrice(entry?.totalPrice?.formattedValue)}}</div>
          </div>
        }
        <div class="order-summary-integrated">
          <div class="summary-row">
            <span>Subtotal ({{orderConfirmationData?.totalUnitCount}} items)</span>
            <span>{{orderConfirmationData?.subTotal?.formattedValue}}</span>
          </div>
          <div class="summary-row">
            <span> {{ orderConfirmationData?.deliveryMode?.name==="Delivery" ? 'Shipping' :orderConfirmationData?.deliveryMode?.name }}</span>
            @if (isOrderConfirmation) {
              <span class="pickup-price">FREE</span>
            }
            @if (!isOrderConfirmation) {
              <span>{{orderConfirmationData?.deliveryCost?.formattedValue}}</span>
            }
          </div>
          <div class="summary-row">
            <span>Sales Tax</span>
            <span>{{orderConfirmationData?.totalTax?.formattedValue}}</span>
          </div>
          <div class="summary-row total">
            <span>Total Amount</span>
            <span>{{orderConfirmationData?.totalPriceWithTax?.formattedValue}}</span>
          </div>
          @if (orderConfirmationData?.cwtPaymentType?.code === 'CARD') {
            <div class="payment-notice">
              Payment Submitted  Successfully
            </div>
          }
        </div>
      </div>
      <!-- PICKUP INFORMATION -->
      <div class="detail-section">
        <h2 class="detail-section-title">
          {{ isOrderConfirmation ? ('orderConfirmation.orderPickuptitle' | cxTranslate) :
          ('orderConfirmation.orderDeliviryTitle' | cxTranslate) }}
        </h2>
        <div class="pickup-info">
          <div class="info-block">
            <div class="info-label">
              {{orderConfirmationData?.deliveryMode?.name}} TYPE
            </div>
            <div class="info-value"> {{ isOrderConfirmation ? ('orderConfirmation.StorePickup' | cxTranslate) :
            ('orderConfirmation.StoreShipping' | cxTranslate) }}</div>
            <div class="status-badge status-confirmed">
              <span>●</span> Confirmed
            </div>
          </div>
          <div class="info-block">
            <div class="info-label">Estimated Scheduled Date</div>
            <div class="info-value large">{{orderConfirmationData?.deliveryContactInfo?.scheduledDeliveryDate | date:'MMMM d, yyyy'}}</div>
          </div>
        </div>
        <div class="store-block">
          <div class="info-label"> {{ isOrderConfirmation ? ('orderConfirmation.pickupLocation' | cxTranslate) :
          ('orderConfirmation.shippingAddress' | cxTranslate) }}</div>
          <div class="store-name"> {{orderConfirmationData?.deliveryAddress?.firstName}} {{orderConfirmationData?.deliveryAddress?.lastName}}  </div>
          <div class="store-details">
            {{orderConfirmationData?.deliveryAddress?.formattedAddress}} <br>
            Phone: {{formatPhone(orderConfirmationData?.deliveryContactInfo?.mobileNumber)}}<br>
            @if (isOrderConfirmation) {
              <div>
                Hours: Mon-Fri 8:00 AM - 5:00 PM
              </div>
            }
          </div>
        </div>
        @if (isOrderConfirmation) {
          <div>
            <div class="pickup-person-block">
              <div class="info-label">Pickup Person</div>
              <div class="person-name">{{orderConfirmationData?.deliveryContactInfo?.firstName}} {{orderConfirmationData?.deliveryContactInfo?.lastName}}</div>
              <div class="person-details">
                Phone: {{formatPhone(orderConfirmationData?.deliveryContactInfo?.mobileNumber)}}<br>
                Please bring a valid ID for pickup
              </div>
            </div>
          </div>
        }
      </div>
      <!-- Delivery Instruction -->
      @if (!isOrderConfirmation) {
        <div>
          <div class="detail-section">
            <h2 class="detail-section-title">
              Shipping Instructions
            </h2>
            <!-- CONTACT PERSONS SECTION -->
            <div class="contact-persons-section">
              <div class="contact-persons-title">Contact Persons for Delivery</div>
              <div class="contact-person">
                <div>
                  <div class="contact-label">Primary Contact</div>
                  <div class="contact-name">{{orderConfirmationData?.deliveryContactInfo?.firstName}} {{orderConfirmationData?.deliveryContactInfo?.lastName}}</div>
                </div>
                <div class="contact-phone"> {{ formatPhone(orderConfirmationData?.deliveryAddress?.phone ?? orderConfirmationData?.deliveryContactInfo?.mobileNumber) }}</div>
              </div>
              <div class="contact-person">
                <div>
                  <div class="contact-label">Additional Contact</div>
                  <div class="contact-name">{{orderConfirmationData?.deliveryContactInfo?.additionalFirstName}} {{orderConfirmationData?.deliveryContactInfo?.additionalLastName}}</div>
                </div>
                <div class="contact-phone">{{formatPhone(orderConfirmationData?.deliveryContactInfo?.additionalMobileNumber)}}</div>
              </div>
            </div>
            <div class="instructions-grid">
              <div class="instruction-item">
                <div class="instruction-label">Location Type</div>
                <div class="instruction-value">{{orderConfirmationData?.deliveryContactInfo?.deliveryInstructions?.deliveryLocation}}</div>
              </div>
              <div class="instruction-item">
                <div class="instruction-label">Lift Gate Required</div>
                <div class="instruction-value">{{orderConfirmationData?.deliveryContactInfo?.deliveryInstructions?.liftGate}}</div>
              </div>
              <div class="instruction-item">
                <div class="instruction-label">Driver Assistance</div>
                <div class="instruction-value">{{orderConfirmationData?.deliveryContactInfo?.deliveryInstructions?.driverAssistance}}</div>
                <div class="address-details">Driver takes to lift gate</div>
              </div>
              <div class="instruction-item">
                <div class="instruction-label">Inside Delivery</div>
                <div class="instruction-value">{{orderConfirmationData?.deliveryContactInfo?.deliveryInstructions?.insideDelivery}}</div>
              </div>
              <div class="instruction-item">
                <div class="instruction-label">Appointment Required</div>
                <div class="instruction-value">{{orderConfirmationData?.deliveryContactInfo?.deliveryInstructions?.deliveryAppointment}}</div>
                <div class="address-details">{{orderConfirmationData?.deliveryContactInfo?.deliveryInstructions?.appointmentTime}}</div>
              </div>
              <div class="instruction-item">
                <div class="instruction-label">Shipping Date</div>
                <div class="instruction-value">{{orderConfirmationData?.deliveryContactInfo?.scheduledDeliveryDate | date:'MMMM d, yyyy'}}</div>
              </div>
            </div>
            <div class="special-handling-block">
              <div class="instruction-label">Special Handling Requirements</div>
              <div class="special-handling-text">
                {{orderConfirmationData?.deliveryContactInfo?.deliveryInstructions?.specialHandlingText}}
              </div>
            </div>
          </div>
        </div>
      }
      <!-- PAYMENT INFORMATION -->
      @if (orderConfirmationData?.cwtPaymentType?.code === 'ACCOUNT') {
        <div class="detail-section">
          <h2 class="detail-section-title">
            Payment Information
          </h2>
          <div class="pickup-info">
            <div class="info-block">
              <div class="info-label">Payment Method</div>
              <div class="info-value">Pay On Account</div>
            </div>
            <div class="info-block">
              <div class="info-label">Sold To Account</div>
              <div class="info-value">{{orderConfirmationData?.soldTo?.customerName}}</div>
              <div class="person-details">Account {{orderConfirmationData?.soldTo?.customerNumber}}</div>
            </div>
          </div>
        </div>
      }
      @if (orderConfirmationData?.cwtPaymentType?.code === 'CARD') {
        <div class="detail-section">
          <h2 class="detail-section-title">
            Payment Information
          </h2>
          <div class="payment-info-grid">
            <div class="payment-method-block">
              <div class="info-label">Payment Method</div>
              <div class="info-value">Credit Card</div>
              <!-- <div class="paid-badge">
                <span>●</span> Submitted
              </div> -->
            </div>
            <div class="card-details-block">
              <div class="info-label">Card Details</div>
              <div class="card-number">{{maskCardNumber(orderConfirmationData?.paymentInfo?.cardNumber)}}</div>
              <div class="card-meta">
                <div class="visa-badge">{{orderConfirmationData?.paymentInfo?.cardType?.name}}</div>
                <span class="card-expiry">Expires {{orderConfirmationData?.paymentInfo?.expiryMonth}}/{{orderConfirmationData?.paymentInfo?.expiryYear}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="transaction-info">
          <div class="transaction-details">
            <span class="transaction-label">Authorized Amount:</span>
            <span class="transaction-value">$466.56</span>
          </div>
        </div> -->
      </div>
    }
  </div>
  <!-- ACTIONS -->
  <div class="actions">
    <a class="btn btn-primary" (click)="navigateToPlp()">
      Continue Shopping
    </a>
    <!-- <div class="contact-info"> -->
    <!-- Questions? Contact us at <strong>(800) 555-0123</strong> or <strong>supporthenryportal.com</strong><br> -->
    <!-- Reference Order #SAP-50012849 -->
  <!-- </div> -->
</div>
</div>
} @else {
  <knbr-cwt-spinner></knbr-cwt-spinner>
}
